import config from "../config";

/**
 * Presigned/SAS storage URLs (S3, Azure Blob, ...) carry their own signature in the URL —
 * an extra Authorization header breaks it regardless of provider. Only attach our app token
 * when the URL actually points at our own API (e.g. local dev serving media directly).
 */
export function shouldAttachApiTokenToImageFetch(url) {
  if (!url || typeof url !== 'string') return false;
  if (url.startsWith('blob:') || url.startsWith('data:')) return false;
  try {
    const apiOrigin = new URL(config.API_BASE_URL, window.location.origin).origin;
    const urlOrigin = new URL(url, window.location.origin).origin;
    return urlOrigin === apiOrigin;
  } catch {
    return false;
  }
}

/** Single network read per remote URL → thumbnail object URL. Avoids <img src=storage-url> + fetch() duplication. */
export async function fetchThumbnail(url) {
  if (!url || typeof url !== 'string') return null;
  if (url.startsWith('data:image/')) return url;
  try {
    let blob;
    if (url.startsWith('blob:')) {
      const r = await fetch(url);
      if (!r.ok) return null;
      blob = await r.blob();
    } else {
      const fetchOpts = {};
      if (shouldAttachApiTokenToImageFetch(url)) {
        fetchOpts.headers = {
          Authorization: `Token ${localStorage.getItem('optha-token')}`,
        };
      }
      const response = await fetch(url, fetchOpts);
      if (!response.ok) return null;
      blob = await response.blob();
    }
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error loading report image:', error);
    return null;
  }
}
